import './bootstrap';

import './lib/animations';

// Website UI Components
import './dmc-components/masonry-gallery';
import './dmc-components/makerlab-environment-background';
import './dmc-components/gallery-carousel';
import './dmc-components/list-variant2-carousel';
import './dmc-components/card-carousel';
import './lib/seam-connector';
import './dmc-components/maker-cog';
import './dmc-components/cursor-delay';
import './dmc-components/submenu';
import './dmc-components/hamburger'
import './dmc-components/table-carousel';
import './dmc-components/case-study';
import './dmc-components/wayfinder';
import './dmc-components/nav-link';

import './dmc-components/news-carousel';
import './dmc-components/event-carousel';
import './dmc-components/offices-carousel';

import './dmc-components/react/office/office-empty';

// import './dmc-components/chatbot';
/// Overlays

import './dmc-components/overlay/enquire';
import './dmc-components/overlay/join-us';

import './dropdown-nav';
import './submenu-nav';

/// Google map

import './google-maps';

// Cookie Consent

import './dmc-components/cookieconsent-init';

// React components

import './dmc-components/react/companies/companies';
import './dmc-components/react/events/events';
import './dmc-components/react/news/news';
import './dmc-components/react/join-us/join-us';
import './dmc-components/lightbox';
import './dmc-components/react/office/index';
import './dmc-components/react/meetings';
import './dmc-components/react/meetings/meeting';
import './dmc-components/react/memberships/index';
import './dmc-components/react/memberships/membership';
import './dmc-components/react/memberships/component';
import './dmc-components/react/events/event';
import './dmc-components/react/co-working/index';

const lightbox = window.GLightbox();
